import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box';
import './Work.css';
import kratinportal from '../../Assets/Work/kratinportal-in.png';
import period from '../../Assets/period.svg';
import {Link} from 'react-router-dom';
import NavBar from "../Navbar";
import Footer from "../Footer";

function KratinPortal() {
  return (
    <section>
      <NavBar />
      <Box className="filebox">

            <Row>
            <aside>
              <Col sm={1}>
                <Container style={{ height: '100%' }}>
                
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '90s' }}>
                Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal         Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal         Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal         Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal         Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal         Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          Kratin Portal          
                </div>
                </div>
                </div>
                </Container>
              </Col>
              <Col sm={10} className="canteen-ui" style={{ paddingLeft: '130px', paddingRight: '70px' }}>
              <Container fluid className="project-section">
          <Container  className="canteen-content">
                <Row className="first-img" style={{ justifyContent: "center", paddingTop: '40px', paddingBottom: "40px" }}>

                <img
                      src={kratinportal}
                      alt="Kratin Portal"
                      className="img-fluid"
                      style={{ padding: '0px'}}
                    />
                  </Row>
                  <Row style={{paddingBottom: "40px"}}>
                    <div style={{display: 'flex'}}>
                  <h1 style={{display: 'flex'}}>Kratin Portal</h1>
                  <img
                    src={period}
                    alt="period"
                    style={{marginLeft: '2px', paddingTop: '1%', verticalAlign: 'bottom' }}
                  />
                  </div>
                  <p className="content">Kratin Portal is a unified platform for all employees that allows them to conveniently access all office-related tasks, from requesting time off to managing work assignments. This platform tends to improve employee engagement, productivity, and collaboration.</p>
                </Row>
                <Row style={{paddingBottom: "56px", fontFamily: 'Changa', fontSize: '1.2em'}} >
                    <Col sm={4}  className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">MY ROLE</p>
                    <p className="box-p">Visual Design Intern, Product Owner</p>
                    </div>
                    </Col>
                    
                    
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TIMELINE</p>
                    <p className="box-p">Febraury, 2023 - Ongoing</p>
                    </div>
                    </Col>
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TOOLS USED</p>
                    <p className="box-p">Figma, PhotoShop, LottieFiles</p>
                    </div>
                    </Col>
                </Row>

                <Row style={{paddingBottom: "32px"}}>
                    <Col>
                    <hr></hr>
                    <div  style={{display: 'flex'}}>
                      <h2 style={{display: 'flex'}}> IMPACT</h2> 
                      <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{ justifyItems: 'start', margin: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">01</p>
                      </Col>
                      <Col>
                      <p className="content"><b className="bold-content">Idea Validation: </b>Conducted market research and user interviews to <b className="bold-content">assess the portal's viability.</b> The proposed idea was found to <b className="bold-content">benefit all employees</b> as it eliminates the need to open multiple apps for different tasks.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">02</p>
                      </Col>
                      <Col>
                      <p className="content"><b className="bold-content">Scope and Feature Analysis:</b> Suggested a solid scope and identified key features that would best <b className="bold-content">meet the user needs.</b></p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">03</p>
                      </Col>
                      <Col>
                      <p className="content"><b className="bold-content">Set Project Timeline: </b> Proposed the <b className="bold-content">workflow of product prioritising leave management and performance management</b>. It reduced the HR workload and boosted their efficiency.</p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">04</p>
                      </Col>
                      <Col>
                      <p className="content"><b className="bold-content">Interface Design:</b> Created all the interfaces ranging from<b className="bold-content"> landing page, leave management, performance management to mini blogs/announcements </b>to ensure a seamless user experience.</p>
                      </Col>
                    </Row>
                    </Col>
                </Row>

                <Row style={{paddingBottom: "32px"}}>
                    <Col>
                    <hr></hr>
                    <div  style={{display: 'flex'}}>
                      <h2 style={{display: 'flex'}}> LEARNINGS</h2> 
                      <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{ justifyItems: 'start', margin: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">01</p>
                      </Col>
                      <Col>
                      <p className="content">Working within <b className="bold-content">scrum and in an agile framework </b>has taught me the <b className="bold-content">strength of collaboration.</b> <b className="bold-content">Coordinated</b> with fellow designers, product managers, and developers to ship end-to-end features.  </p>
                      </Col>
                    </Row>
                    <Row>
                    <Col sm={1} className="bullet-points">
                      <p className="bold-content">02</p>
                      </Col>
                      <Col>
                      <p className="content">Effectively <b className="bold-content">juggled academic responsibilities and professional commitments</b>, demonstrating the <b className="bold-content">value of time management</b>. There were numerous instances where deadlines clashed and tasks had to be prioritized accordingly.</p>
                      </Col>
                    </Row>
                    <Row>
                        <Col sm={1} className="bullet-points">
                          <p className="bold-content-bold">03</p>
                        </Col>
                        <Col>
                          <p className="content">Understood the importance of<b className="content-bold"> attention to detail </b> as a minor misalignment has a negative impact on the look and feel of the design <b className="bold-content">thereby making a sizable impact</b> on the user experience.</p>
                        </Col>
                      </Row>
                    
                    </Col>
                </Row>
                <Row style={{marginBottom: "100px", paddingTop:"40px",  fontFamily: 'Changa', fontSize: '1.2em'}}>
                  <Link to={'/experience/truliacareinsights'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute'}}>
                    Previous
                    </div>
                  </Link>
                  <Link to={'/experience/kratinbranding'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute', right:'0px'}}>
                    Next
                    </div>
                  </Link>
                </Row>      
                
            </Container>
                </Container>
              </Col>
              </aside>
            </Row>
        <Footer />
      </Box>
    </section>
  );
}

export default KratinPortal;
